/**
 * Clases compartidas por todos los controles de formulario.
 *
 * Existe para que un `<input>`, un `<select>` y el combobox de un many2one se
 * vean como el mismo objeto. Sin esto, cada widget inventa su propio alto y el
 * formulario queda escalonado.
 *
 * El anillo de foco no se define aca: lo pone `:focus-visible` global en
 * `index.css`, que ya distingue teclado de mouse.
 */

import clsx from 'clsx';

/** Alto minimo tactil en movil (44px) y compacto en escritorio. */
const BASE =
  'block w-full rounded-md border bg-surface px-3 text-sm text-fg transition-colors ' +
  'min-h-[2.75rem] py-2 sm:min-h-0 sm:h-9 sm:py-1.5 ' +
  'disabled:cursor-not-allowed disabled:bg-surface-raised disabled:text-fg-muted';

export function controlClass(invalid: boolean, extra?: string): string {
  return clsx(
    BASE,
    invalid ? 'border-danger focus:border-danger' : 'border-line hover:border-line-strong focus:border-accent',
    extra,
  );
}

/** Igual que {@link controlClass} pero sin alto fijo: textarea, grillas, chips. */
export function areaClass(invalid: boolean, extra?: string): string {
  return clsx(
    'block w-full rounded-md border bg-surface px-3 py-2 text-sm text-fg transition-colors',
    invalid ? 'border-danger focus:border-danger' : 'border-line hover:border-line-strong focus:border-accent',
    extra,
  );
}

/** Valor de solo lectura. `<output>` es etiquetable, asi que la label sigue funcionando. */
export const READONLY_CLASS =
  'block w-full rounded-md border border-transparent bg-surface-raised px-3 py-2 text-sm text-fg sm:py-1.5';
